import { render } from "./awaitVBtn.vue?vue&type=template&id=ac3570e0"
import script from "./awaitVBtn.vue?vue&type=script&lang=js"
export * from "./awaitVBtn.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__